import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { limit } from "firebase/firestore";
import { AvailityServiceReviewConfiguration } from "risa-data-model";
import { FirestoreService } from "../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../shared/api/firebase/references";
import { logError } from "../../utils/customLogger";

interface AvailityServiceReviewConfigurationDetails {
  data?: AvailityServiceReviewConfiguration | null;
  loading: boolean;
  error: string | null;
}

const initialState: AvailityServiceReviewConfigurationDetails = {
  data: null,
  loading: false,
  error: null,
};

const availityServiceReviewConfigurationSlice = createSlice({
  name: "availityServiceReviewConfiguration",
  initialState,
  reducers: {
    fetchAvailityServiceReviewConfigurationStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAvailityServiceReviewConfigurationSuccess(
      state,
      action: PayloadAction<AvailityServiceReviewConfiguration | null>,
    ) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchAvailityServiceReviewConfigurationFailure(
      state,
      action: PayloadAction<string>,
    ) {
      state.error = action.payload;
      state.loading = false;
    },
    updateAvailityServiceReviewConfiguration(
      state,
      action: PayloadAction<AvailityServiceReviewConfiguration>,
    ) {
      state.data = action.payload;
    },
  },
});

export const {
  fetchAvailityServiceReviewConfigurationStart,
  fetchAvailityServiceReviewConfigurationSuccess,
  fetchAvailityServiceReviewConfigurationFailure,
  updateAvailityServiceReviewConfiguration,
} = availityServiceReviewConfigurationSlice.actions;

export const fetchAvailityServiceReviewConfiguration =
  (orderId: string) => async (dispatch) => {
    dispatch(fetchAvailityServiceReviewConfigurationStart());
    try {
      FirestoreService.listenToQueryCollection<
        AvailityServiceReviewConfiguration[]
      >(
        FirestoreCollectionReference.availityServiceReviewConfiguration(
          orderId,
        ),
        (docs) => {
          if (docs.length > 0) {
            const firstDoc = docs[0] as AvailityServiceReviewConfiguration;
            dispatch(fetchAvailityServiceReviewConfigurationSuccess(firstDoc));
          } else {
            dispatch(fetchAvailityServiceReviewConfigurationSuccess(null));
          }
        },
        (error) => {
          dispatch(
            fetchAvailityServiceReviewConfigurationFailure(error.message),
          );
        },
        limit(1),
      );
    } catch (error: any) {
      logError(error, "Error fetching Availity Service Review Configuration");
      dispatch(fetchAvailityServiceReviewConfigurationFailure(error.message));
    }
  };

export default availityServiceReviewConfigurationSlice.reducer;
